import Box from '@mui/material/Box';
import Shimmer from './Shimmer';

// Skeleton for the Blog "All Articles" index view (the landing state).
// Mirrors the 3-col category grid where each column has a Bebas-style
// section header + a ruled list of numbered article titles.
//
// Scoped to the main content area only — the forest-green hero, stats
// row and category-nav strip render immediately from their own queries
// (or a '—' fallback), so shimmering them would flash for one frame
// and then snap. Keeping the shimmer to the slowest-to-arrive section
// matches the pattern used on Tests / Packages.

const BlogColumnShimmer = ({ rows = 7 }) => (
  <Box>
    {/* Category header (icon + label) */}
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, mb: 1.5 }}>
      <Shimmer width={22} height={22} rounded={4} />
      <Shimmer width={130} height={18} rounded={4} />
    </Box>

    {/* Numbered article rows */}
    {Array.from({ length: rows }).map((_, i) => (
      <Box
        key={i}
        sx={{
          borderBottom: '1px solid var(--border-l, #E0DDD6)',
          py: 1.25,
          display: 'flex',
          alignItems: 'flex-start',
          gap: 1.25,
        }}
      >
        <Shimmer width={18} height={9} rounded={3} sx={{ mt: 0.5 }} />
        <Box sx={{ flex: 1 }}>
          <Shimmer width="95%" height={12} rounded={4} sx={{ mb: 0.5 }} />
          <Shimmer width={`${55 + (i * 11) % 35}%`} height={12} rounded={4} />
        </Box>
      </Box>
    ))}
  </Box>
);

const BlogShimmer = ({ columns = 3 }) => (
  <Box sx={{ py: 8, px: { xs: 3, md: 6 }, maxWidth: 1200, mx: 'auto' }}>
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', md: `repeat(${columns}, 1fr)` },
        gap: 4,
      }}
    >
      {Array.from({ length: columns }).map((_, i) => (
        <BlogColumnShimmer key={i} rows={6 + (i % 2)} />
      ))}
    </Box>
  </Box>
);

export default BlogShimmer;
